document.querySelectorAll('.room-teaser-carousel-block').forEach(el => {
    const controls = el.querySelector("[data-slider-controls]");
    try {
        const slider = tns({
            container: el.querySelector("[data-room-teaser-carousel-block-slider]"),
            items: 1,
            edgePadding: 0,
            autoplay: true,
            controls: true,
            controlsContainer: controls,
            autoplayButton: false,
            autoplayTimeout: 5000,
            center: true,
            gutter: 20,
            nav: false,
            loop: true,
            responsive: {
                "768": { "items": 1, "edgePadding": 0 },
                "992": { "fixedWidth": 780 },
                "1200": { "fixedWidth": 1130, gutter: 50 }
            }
        });
    } catch (error) {
        console.error("Error initializing Tiny Slider:", error);
    }

    el.querySelectorAll('[data-room-teaser-carousel-block-controls]').forEach(c => {
        c.removeAttribute('aria-label');
    });
});